import {get, useSelector} from 'helpers';
import * as selectors from 'store';

export function useNamedSelector(path: string, ...options: any[]) {
  const selector = get(selectors, path);
  if (!path) {
    throw new Error('Selector not specified');
  } else if (typeof selector !== 'function') {
    throw new Error(`Selector "${path}" not found`);
  } else if (options.length) {
    return useSelector(state => selector(...[state, ...options]));
  }
  return useSelector(selector);
}
